import { render, staticRenderFns } from "./ModalTributacao.vue?vue&type=template&id=0b6965f9&scoped=true"
import script from "./ModalTributacao.vue?vue&type=script&lang=js"
export * from "./ModalTributacao.vue?vue&type=script&lang=js"
import style0 from "./ModalTributacao.vue?vue&type=style&index=0&id=0b6965f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6965f9",
  null
  
)

export default component.exports